<tp-modal dialogTitle="Create new space" [isBusy]="isSubmitting$ | async">
  <tp-form [formGroup]="form" [isSubmitting$]="isSubmitting$" (doSubmit)="submit()">
    <tp-form-input type="text" [form]="form" field="id" label="Space ID" />
    <tp-form-input type="text" [form]="form" field="name" label="Space Name" />
    <tp-form-actions
      [cancellable]="true" submitText="Create" [isSubmitting]="isSubmitting$ | async"
      buttonIdPrefix="createSpaceModal" (cancel)="close()"
    />
  </tp-form>
</tp-modal>
